export enum LoginPhase {
  LOGIN = 'login',
  LOGOUT = 'logout',
  EXPIRED_PASSWORD = 'expired_password',
  EMAIL_REQUIRED_BLOCKED = 'email_required_blocked',
  LOGGED_IN = 'logged_in',
}
